import React from 'react';

/**
 * 공통 라떼 버튼 컴포넌트
 * @param {Object} props
 * @param {string} props.variant - 버튼 스타일 ('primary', 'secondary', 'outline', 'ghost', 'gradient', 'portfolio', 'muted', 'subtle', 'minimal')
 * @param {string} props.size - 버튼 크기 ('sm', 'md', 'lg', 'xl')
 * @param {React.ReactNode} props.children - 버튼 내용
 * @param {string} props.className - 추가 CSS 클래스
 * @param {boolean} props.disabled - 비활성화 상태
 * @param {function} props.onClick - 클릭 핸들러
 * @param {string} props.type - 버튼 타입
 * @param {boolean} props.fullWidth - 전체 너비 사용 여부
 */
const LatteButton = ({ 
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  disabled = false,
  onClick,
  type = 'button',
  fullWidth = false,
  ...props
}) => {
  // 크기 매핑
  const sizeMap = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm', 
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-4 text-lg'
  };

  // 변형 스타일 매핑
  const variantMap = {
    primary: 'btn-latte',
    secondary: 'btn-secondary',
    outline: 'btn-latte-outline',
    ghost: 'btn-latte-ghost',
    danger: 'btn-danger',
    'danger-ghost': 'btn-danger-ghost',
    gradient: 'btn-gradient',
    portfolio: 'btn-portfolio-gradient',
    muted: 'btn-latte-muted',
    subtle: 'btn-latte-subtle',
    minimal: 'btn-latte-minimal'
  };

  const buttonSize = sizeMap[size] || sizeMap.md;
  const buttonStyle = variantMap[variant] || variantMap.primary;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center gap-2 
        font-medium rounded-lg 
        transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-latte-500 focus:ring-offset-2
        disabled:opacity-50 disabled:cursor-not-allowed
        ${buttonSize} 
        ${buttonStyle} 
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};

export default LatteButton;

// 편의 함수들 export
export const LattePrimaryButton = (props) => <LatteButton variant="primary" {...props} />;
export const LatteSecondaryButton = (props) => <LatteButton variant="secondary" {...props} />;
export const LatteOutlineButton = (props) => <LatteButton variant="outline" {...props} />;
export const LatteGhostButton = (props) => <LatteButton variant="ghost" {...props} />;
export const LatteGradientButton = (props) => <LatteButton variant="gradient" {...props} />;
export const LattePortfolioButton = (props) => <LatteButton variant="portfolio" {...props} />;
export const LatteMutedButton = (props) => <LatteButton variant="muted" {...props} />;
export const LatteSubtleButton = (props) => <LatteButton variant="subtle" {...props} />;
export const LatteMinimalButton = (props) => <LatteButton variant="minimal" {...props} />;
